import { __rest, __assign } from '../../_virtual/_tslib.js';
import React from 'react';
import classnames from 'classnames';
import camelCase from 'lodash/camelCase';
import styles from './styles.css.js';
import check from './icons/check.svg.js';
import * as icons from './icons/index.js';

var ExpertProfileHighlightIcon = function ExpertProfileHighlightIcon(_a) {
  var glyph = _a.glyph,
      className = _a.className,
      rest = __rest(_a, ["glyph", "className"]);

  var classes = classnames(styles.icon, className);
  var exportName = camelCase(glyph);
  var Icon; // @ts-ignore typescript doesn't recognize the glob import

  Icon = icons[exportName] || check;
  return React.createElement(Icon, __assign({
    className: classes
  }, rest));
};

export default ExpertProfileHighlightIcon;
//# sourceMappingURL=index.js.map
